
export default {
    name: 'JsonPage',

    props: {
        model: {
            type: Object,
            default: () => ({}),
        },

        extra: {
            type: null,
            default: () => ({}),
        }
    },

    computed: {
        blocks() {
            return this.model.blocks || []
        },
    }
}
